<template>
  <div>
      <v-toolbar flat color="white">
          <v-toolbar-title>Items de evaluación</v-toolbar-title>
          <v-divider
              class="mx-2"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                  <v-card-title>
                      <span v-show="!editingItem" class="headline">Nuevo</span>
                      <span v-show="editingItem" class="headline">Editar</span>
                  </v-card-title>
                  <v-card-text>
                    <v-select
                      :form="form"
                      label="Evaluador"
                      :error-messages="errors.collect('evaluator')"
                      :items="evaluator_options"
                      v-model="form.evaluator"
                      name="evaluator"
                      v-validate="'required'"
                    ></v-select>

                    <v-text-field
                      :form="form"
                      label="Áreas a evaluar"
                      :error-messages="errors.collect('area')"
                      v-model="form.area"
                      name="area"
                    ></v-text-field>

                    <v-text-field
                      :form="form"
                      label="Estándar"
                      :error-messages="errors.collect('standard')"
                      v-model="form.standard"
                      name="standard"
                      v-validate="'required'"
                    ></v-text-field>

                    <template>
                      <v-range-slider
                        :form="form"
                        label="Rango de calificación"
                        v-model="form.range"
                        step="1"
                        :max="10"
                        :min="0"
                        thumb-label="always"
                        name="range"
                      ></v-range-slider>
                    </template>
                    
                    <v-layout row>
                      <v-flex xs6 px-1>
                        <v-text-field
                          label="Ponderación familia nueva"
                          suffix="%"
                          v-model="weight_nueva"
                          type="number"
                        />
                      </v-flex>
                      
                      <v-flex xs6 px-1>
                        <v-text-field
                          label="Ponderación familia vinculada"
                          suffix="%"
                          v-model="weight_vinculada"
                          type="number"
                        />
                      </v-flex>
                    </v-layout>

                    <check-input
                      name="auto"
                      :form="form"
                      label="Automático"
                      :value.sync="form.auto"
                      :color="'primary'"
                      :v-errors="errors"
                    >
                    </check-input>
                    <div v-if="form.auto">
                      <v-layout v-for="(item, index) in form.condition" row wrap mt-2 align-center :key="index">
                        <v-flex xs6 px-1>
                          <v-select
                            :form="form"
                            label="Columna"
                            :error-messages="errors.collect('column')"
                            :items="score_columns"
                            v-model="form.condition[index].column"
                            name="column"
                            v-validate="'required'"
                          ></v-select>
                        </v-flex>
                        
                        <v-flex xs6 px-1>
                          <v-text-field
                            label="Calificación"
                            v-model.number="form.condition[index].score"
                            type="number"
                            min="0"
                            v-validate="'required'"
                          />
                        </v-flex>
                      </v-layout>
                      <div style="text-align: center;">
                        <v-btn color="primary" dark @click="addCondition()">Añadir condición</v-btn>
                      </div>
                    </div>

                    <check-input
                      name="status"
                      :form="form"
                      :label="$t('admissions.settings.form.status')"
                      :value.sync="form.status"
                      :color="'primary'"
                      :v-errors="errors"
                    >
                    </check-input>

                  </v-card-text>

                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="close">{{$t('admissions.settings.form.cancel')}}</v-btn>
                      <v-btn v-if="!editingItem" color="blue darken-1" flat @click="saveItem">{{$t('admissions.settings.form.save')}}</v-btn>
                      <v-btn v-else color="blue darken-1" flat @click="updateItem">{{$t('admissions.settings.form.update')}}</v-btn>
                  </v-card-actions>
              </v-card>
          </v-dialog>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="score_items"
          :loading="loadingTable"
          class="elevation-1"
      >
          <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.id }}</td>
              <td class="text-xs-center">{{ props.item.evaluator }}</td>
              <td class="text-xs-center">{{ props.item.area }}</td>
              <td class="text-xs-center">{{ props.item.standard }}</td>
              <td class="text-xs-center">{{ props.item.range }}</td>
              <td class="text-xs-center">{{ props.item.auto }}</td>
              <td class="text-xs-center">{{ props.item.weight_nueva * 100 }}% / {{ props.item.weight_vinculada * 100 }}%</td>
              <td class="text-xs-center">{{ props.item.status }}</td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item.id)"
                    slot="activator"
                  >
                    edit
                  </v-icon>
                  <span>{{$t('admissions.settings.edit')}}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-icon
                    medium
                    class="mr-2"
                    @click="deleteItem(props.item.id)"
                    slot="activator"
                  >
                    delete
                  </v-icon>
                  <span>{{$t('admissions.settings.delete')}}</span>
                </v-tooltip>
              </td>
          </template>
      </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
export default {
name: 'admissions-items-list',
data() {
  return {
    headers: [
      { text: 'Id', align: 'center', value: 'id' },
      { text: 'Evaluador', align: 'center', value: 'evaluator' },
      { text: 'Áreas', align: 'center', value: 'area' },
      { text: 'Estándar', align: 'center', value: 'standard' },
      { text: 'Rango', align: 'center', value: 'range_from' },
      { text: 'Auto', align: 'center', value: 'auto' },
      { text: 'Ponderación', align: 'center', value: 'weight' },
      { text: this.$t('admissions.settings.form.status'), align: 'center', value: 'status' },
      { text: this.$t('admissions.settings.form.actions'), align: 'center', value: 'actions', sortable: false }
    ],
    score_items: [],
    score_columns: [],
    evaluator_options: [
      {value: 'ADMISIONES', text: 'ADMISIONES'},
      {value: 'CONSEJERÍA', text: 'CONSEJERÍA'},
      {value: 'RECTORÍA/COMITE', text: 'RECTORÍA/COMITE'}
    ],
    isLoading: false,
    loadingTable: false,
    dialog: false,
    form: new Form({
      evaluator: '',
      area: '',
      standard: '',
      range: [0, 4],
      auto: false,
      condition: [],
      weight_nueva: 0,
      weight_vinculada: 0,
      status: true,
    }),
    showSucessMessage: false,
    editingItem: false,
  }
},
watch: {
  dialog(val) {
    val || this.close()
  }
},
created() {
  this.getItems()
},
computed: {
    weight_nueva: {
      get: function(){
        return +(this.form.weight_nueva * 100).toFixed(2)
      },
      set: function(newValue){
        this.form.weight_nueva = (newValue / 100).toFixed(3)
      }
    },
    weight_vinculada: {
      get: function(){
        return +(this.form.weight_vinculada * 100).toFixed(2)
      },
      set: function(newValue){
        this.form.weight_vinculada = (newValue / 100).toFixed(3)
      }
    }
  },
methods: {
  async getItems() {
    this.loadingTable = true;
    let { data } = await axios.get('/api/admissions/score_items')
    this.score_items = data.items;
    this.score_columns = data.columns;
    this.loadingTable = false;
  },
  close() {
    this.form = new Form({
      evaluator: '',
      area: '',
      standard: '',
      range: [0, 4],
      auto: false,
      condition: [],
      weight_nueva: 0,
      weight_vinculada: 0,
      status: true,
    }),
    this.dialog = false
    this.editingItem = false
  },
  addCondition() {
    this.form.condition.push({column: null, score: 0});
  },
  async saveItem() {
    if (await this.formHasErrors()) return

    const result = await this.form.post('/api/admissions/score_items', this.form)

    if (result.status === 200) {
      this.getItems()
      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('admissions.settings.messages.saved_ok'),
        modal: false
      })
    }

    this.close()
  },
  editItem(id_item) {
    const ItemToEdit = this.score_items.filter(type => type.id === id_item)[0];
    this.editingItem = true;
    this.dialog = true;
    this.form = new Form({
      id: ItemToEdit.id,
      evaluator: ItemToEdit.evaluator,
      area: ItemToEdit.area,
      standard: ItemToEdit.standard,
      range: ItemToEdit.range,
      auto: ItemToEdit.auto == 1 ? true : false,
      condition: ItemToEdit.condition,
      weight_nueva: ItemToEdit.weight_nueva,
      weight_vinculada: ItemToEdit.weight_vinculada,
      status: ItemToEdit.status == 1 ? true : false,
    });

  },
  deleteItem(id_item) {
    if(confirm("¿Está seguro de que quiere eliminar esta entrada?")){
      axios.delete(`/api/admissions/score_items/${id_item}`)
        .then(resp => {
          if (resp.status === 200) {
            this.getItems()
          }
        })
        .catch(error => console.log(error));
    }
  },
  updateItem() {
    this.form.put('/api/admissions/score_items')
      .then(resp => {
        if (resp.status === 200) {
            this.getItems()
            this.close()
            this.editingItem = false;
        }
      })
      .catch(error => console.log(error));
  },
  onlyNumbers($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if(keyCode == 45) { //This is a code por - (minus sign)
          $event.preventDefault();
      }
  },
}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/score_items.vue